/**
 * Created by carlhaynes on 9/25/17.
 */
import React, { Component } from 'react';
import '../App.css';
import {withRouter} from 'react-router-dom'
import { Grid, Row, PageHeader } from 'react-bootstrap';

class Contact extends Component {

  render() {


    return (
          <Grid>
              <Row>
                  <PageHeader>Contact</PageHeader>
              </Row>
              <Row>
              </Row>
          </Grid>
    );
  }
}

export default withRouter(Contact);



// WEBPACK FOOTER //
// ./src/pages/Contact.jsx